/**
 * TheNewsPulse — public UI entry point.
 *
 * Renders when siteConfig resolves to the `newspulse` slug (i.e. host
 * matches thenewspulse.pro / newspulse.pro / aliased preview).
 * All routes live under this component's <Routes> so we can keep them
 * scoped away from the main SocialPulse app router.
 */
import { Routes, Route, Navigate } from "react-router-dom";
import NewsPulseContributor        from "./NewsPulseContributor";
import NewsPulseContributeSubmit   from "./NewsPulseContributeSubmit";
import NewsPulseMyContributions    from "./NewsPulseMyContributions";
import NewsPulseAdminContributions from "./NewsPulseAdminContributions";
import NewsPulseReporterProfile    from "./NewsPulseReporterProfile";
import NewsPulseLayout from "./NewsPulseLayout";
import NewsPulseHome from "./NewsPulseHome";
import NewsPulseEventDetail from "./NewsPulseEventDetail";
import NewsPulseTopic from "./NewsPulseTopic";
import NewsPulseWhatChanged from "./NewsPulseWhatChanged";
import NewsPulseSearch from "./NewsPulseSearch";
import NewsPulseAbout from "./NewsPulseAbout";
import NewsPulseBreaking from "./NewsPulseBreaking";
import NewsPulseAdminFeeds from "./NewsPulseAdminFeeds";
import NewsPulseAviationHub from "./NewsPulseAviationHub";
import NewsPulseAirportProfile from "./NewsPulseAirportProfile";
import NewsPulseAirlineProfile from "./NewsPulseAirlineProfile";
import NewsPulseFarmersPulse from "./NewsPulseFarmersPulse";
import NewsPulseOpinion from "./NewsPulseOpinion";
import NewsPulseForYou from "./NewsPulseForYou";
import NewsPulseLocal from "./NewsPulseLocal";

export default function NewsPulseApp() {
  return (
    <Routes>
      <Route element={<NewsPulseLayout />}>
        <Route index element={<NewsPulseHome />} />
        <Route path="event/:eventId" element={<NewsPulseEventDetail />} />
        <Route path="topic/:path" element={<NewsPulseTopic />} />
        <Route path="breaking" element={<NewsPulseBreaking />} />
        <Route path="what-changed" element={<NewsPulseWhatChanged />} />
        <Route path="search" element={<NewsPulseSearch />} />
        <Route path="about" element={<NewsPulseAbout />} />
        <Route path="aviation" element={<NewsPulseAviationHub />} />
        <Route path="aviation/airport/:airportId" element={<NewsPulseAirportProfile />} />
        <Route path="aviation/airline/:airlineId" element={<NewsPulseAirlineProfile />} />
        <Route path="farmerspulse" element={<NewsPulseFarmersPulse />} />
        <Route path="opinion" element={<NewsPulseOpinion />} />
        <Route path="opinion/:subtopic" element={<NewsPulseOpinion />} />
        <Route path="for-you" element={<NewsPulseForYou />} />
        <Route path="local" element={<NewsPulseLocal />} />
        <Route path="admin/feeds" element={<NewsPulseAdminFeeds />} />
        <Route path="contribute"       element={<NewsPulseContributor />} />
        <Route path="contribute/new"   element={<NewsPulseContributeSubmit />} />
        <Route path="contribute/mine"  element={<NewsPulseMyContributions />} />
        <Route path="admin/contributions" element={<NewsPulseAdminContributions />} />
        <Route path="reporter/:userId" element={<NewsPulseReporterProfile />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
